import { Checkbox, FormControlLabel, makeStyles, Typography } from '@material-ui/core';
import React, { ReactNode, useState } from 'react';

import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';

interface OwnProps {
  label?: string;
  name?: string;
  size?: 'medium' | 'small';
  mandatory?: boolean;
  refReg?: any;
  icon?: ReactNode;
  defaultValue?: boolean;
  colorCheckbox?: 'primary' | 'secondary' | 'default';
  onChange?: (value: boolean) => void;
  indeterminate?: boolean;
  disabled?: boolean; // <-- Add this line
}

const InputCheckbox: React.FC<OwnProps> = ({
  label = '',
  name = '',
  size = 'medium',
  mandatory = false,
  refReg,
  icon,
  defaultValue = false,
  colorCheckbox = 'primary',
  onChange,
  indeterminate = false,
  disabled, // <-- Add this line
}) => {
  const classes = useStyles();
  const [state, setState] = useState(defaultValue);

  useDefaultValueWatcher({ defaultValue, state, setState });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.checked);
    }
    setState(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          className="checkbox"
          checked={state}
          onChange={handleChange}
          color={colorCheckbox}
          inputProps={{ name: name }}
          indeterminate={indeterminate}
          inputRef={refReg}
          size={size}
          disabled={disabled} // <-- Add this line
        />
      }
      label={
        mandatory ? (
          `${label} *`
        ) : (
          <Typography className={classes.labelText}>
            {icon ? icon : null} {label}
          </Typography>
        )
      }
    />
  );
};

const useStyles = makeStyles((theme) => ({
  labelText: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      width: theme.spacing(7),
      marginRight: theme.spacing(3),
      color: theme.palette.secondary.dark,
    },
  },
}));

export default InputCheckbox;
